import { Directive, ElementRef, Renderer2, OnInit } from '@angular/core';

@Directive({
  selector: '[nimbusPrimaryIconButton]',
  standalone: false,
})
export class NimbusMaterialIconPrimaryButtonDirective implements OnInit {
  public constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  public ngOnInit(): void {
    this.renderer.addClass(this.elementRef.nativeElement, 'nimbus-material-icon-button');
    this.renderer.addClass(this.elementRef.nativeElement, 'primary');
  }
}
